import { AnyAction } from 'redux';
import { ActionTypes, IStorageAccess } from 'store/storage/types';

const storageReducer = (
  // eslint-disable-next-line @typescript-eslint/default-param-last
  state: IStorageAccess = {
    isStorageActive: null,
    loading: false,
    error: null,
    uploading: {
      progress: null,
      files: [],
      error: null,
    },
  },
  { type, payload }: AnyAction,
): IStorageAccess => {
  switch (type) {
    case ActionTypes.SET_IS_ACTIVE:
      return { ...state, isStorageActive: payload };
    case ActionTypes.SET_LOADING:
      return { ...state, loading: false };
    case ActionTypes.SET_ERROR:
      return { ...state, error: payload };
    case ActionTypes.START_UPLOAD:
      return {
        ...state,
        uploading: {
          files: payload, progress: 0, error: null,
        },
      };
    case ActionTypes.SET_PROGRESS: {
      return { ...state, uploading: { ...state.uploading, progress: payload } };
    }
    case ActionTypes.STOP_UPLOAD: {
      return { ...state, uploading: { files: [], progress: null, error: null } };
    }
    case ActionTypes.SET_UPLOAD_ERROR: {
      return { ...state, uploading: { ...state.uploading, progress: null, error: payload } };
    }
    default:
      return state;
  }
  return state;
};

export default storageReducer;
